import React from 'react';
import { Link } from 'react-router-dom';
import { LiveDonate, formatLiveAgo } from '../../utils/live-donate';
import { formatCa } from '../../utils/donate-alert';

/**
 * Các dòng "A donate cho B · 100.000 Ca · 2 phút trước". Không hiện lời nhắn.
 *
 * `now`: mốc giờ hiện tại do component cha (đang tick mỗi 30 giây) truyền xuống, để dòng chữ
 * "x phút trước" tự cập nhật theo thời gian thực thay vì tính một lần lúc render rồi đứng yên.
 */
const LiveDonateList: React.FC<{ items: LiveDonate[]; freshId?: string | null; now: number }> = ({
  items,
  freshId,
  now,
}) => (
  <ul className="flex flex-col gap-2">
    {items.map((d) => (
      <li
        key={d.id}
        className={`rounded-lg px-3 py-2 text-sm transition-colors duration-700 ${
          d.id === freshId ? 'bg-amber-100 dark:bg-amber-900/40' : 'bg-transparent'
        }`}
      >
        <div className="text-gray-800 dark:text-gray-100 break-words">
          {d.donorUserName ? (
            <Link to={`/user/${d.donorUserName}`} className="font-semibold hover:underline">{d.donorName}</Link>
          ) : (
            <span className="font-semibold">{d.donorName}</span>
          )}{' '}
          donate cho{' '}
          {d.creatorUserName ? (
            <Link to={`/user/${d.creatorUserName}`} className="font-semibold text-blue-600 hover:underline">{d.creatorName}</Link>
          ) : (
            <span className="font-semibold">{d.creatorName}</span>
          )}
        </div>
        <div className="mt-0.5 flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400">
          <span className="font-semibold text-amber-600 dark:text-amber-400">{formatCa(d.amount)}</span>
          <span>·</span>
          <span>{formatLiveAgo(d.createdAt, now)}</span>
        </div>
      </li>
    ))}
  </ul>
);

export default LiveDonateList;
